@if (tableData !== null) {
  <div class="table-wrapper" [class.inputs-enabled]="!inputsDisabled" [class.inputs-disabled]="inputsDisabled">
    <mat-table [dataSource]="tableData.rows" [trackBy]="trackByRowId">

      <ng-container matColumnDef="label" [sticky]="true">
        <mat-header-cell *matHeaderCellDef>
          <button mat-stroked-button class="table-button" (click)="createExport()">Exporteer</button>
          @if (!this.inputsDisabled) {
            <button mat-stroked-button class="table-button" (click)="fileInput.click()">Importeer</button>
            <div style="display: none">
              <input type="file" #fileInput [accept]="acceptedDocumentTypes" (change)="onFileSelected($event)" class="hidden">
            </div>
          }
        </mat-header-cell>
        <mat-cell *matCellDef="let row">{{row.label}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="groeplabel" [sticky]="true">
        <mat-header-cell *matHeaderCellDef>Groepnaam</mat-header-cell>
        <mat-cell *matCellDef="let row">{{row.groeplabel}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="totalen">
        <mat-header-cell *matHeaderCellDef  class="number-column">Totalen</mat-header-cell>
        <mat-cell *matCellDef="let row; let i = index;" class="number-column number-input-cell">
          @if (inputsDisabled) {
            {{row.totalen}}
          } @else {
            <input type="text"
                   class="number-input"
                   [attr.data-row]="i"
                   [attr.data-column]="'totaal'"
                   [disabled]="row.disabled"
                   (keydown)="handleCellNavigation($event)"
                   [class]="'cell_totaal_' + i"
                   [value]="row.totalen ?? ''"
                   (change)="updateCategorieField($event, row.id, 'totaalGepland')" />
          }
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="total_check">
        <mat-header-cell *matHeaderCellDef  class="number-column">Check</mat-header-cell>
        <mat-cell *matCellDef="let row"
                  class="number-column"
                  [class.check-success]="row.total_check === 0"
                  [class.check-failed]="row.total_check !== 0">{{row.total_check}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="gerealiseerd">
        <mat-header-cell *matHeaderCellDef  class="number-column">Gerealiseerd</mat-header-cell>
        <mat-cell *matCellDef="let row; let i = index;" class="number-column number-input-cell">
          @if (inputsDisabled) {
            {{row.gerealiseerd}}
          } @else {
            <input type="text"
                   class="number-input"
                   [attr.data-row]="i"
                   [attr.data-column]="'gerealiseerd'"
                   [disabled]="inputsDisabled || row.disabled"
                   (keydown)="handleCellNavigation($event)"
                   [class]="'cell_gerealiseerd_' + i"
                   [value]="row.gerealiseerd ?? ''"
                   (change)="updateCategorieField($event, row.id, 'totaalGerealiseerd')" />
          }
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="restcapaciteit">
        <mat-header-cell *matHeaderCellDef  class="number-column info-cell">Restcapaciteit</mat-header-cell>
        <mat-cell *matCellDef="let row" class="number-column info-cell">{{row.restcapaciteit}}</mat-cell>
      </ng-container>

      @for (year of yearColumns; track $index) {
        <ng-container [matColumnDef]="'year_' + year">
          <mat-header-cell *matHeaderCellDef class="year number-column" [class.check-failed]="isInvalidColumn(tableData.yearColumns, 'year_' + year)">{{year}}</mat-header-cell>
          <mat-cell *matCellDef="let row; let i = index;" class="year number-input-cell" [class.info-cell]="row.id === 'sloop-sloop'">
            @if (row.id !== 'sloop-sloop') {
              @if (inputsDisabled) {
                {{row['year_' + year]}}
              } @else {
                <input type="text"
                       class="number-input"
                       pattern="0-9"
                       [attr.data-row]="i"
                       [attr.data-column]="year"
                       [disabled]="row.disabled"
                       (keydown)="handleCellNavigation($event)"
                       [class]="'cell_' + year + '_' + i"
                       [value]="row['year_' + year]"
                       (change)="updateDetailField($event, row.id, year)" />
              }
            }
          </mat-cell>
        </ng-container>
      }

      <ng-container matColumnDef="year_2043">
        <mat-header-cell *matHeaderCellDef class="year number-column expand-collapse-container" [class.check-failed]="isInvalidColumn(tableData.yearColumns, 'year_2043')">
          2043
          <button mat-button class="expand-collapse" (click)="toggleExpanded()"><mat-icon svgIcon="chevron_left"></mat-icon></button>
        </mat-header-cell>
        <mat-cell *matCellDef="let row; let i = index;" class="year number-input-cell" [class.info-cell]="row.id === 'sloop-sloop'">
          @if (row.id !== 'sloop-sloop') {
            @if (inputsDisabled) {
              {{row.year_2043}}
            } @else {
              <input type="text"
                     class="number-input"
                     [attr.data-row]="i"
                     [attr.data-column]="2043"
                     [disabled]="inputsDisabled || row.disabled"
                     (keydown)="handleCellNavigation($event)"
                     [class]="'cell_2043_' + i"
                     [value]="row.year_2043"
                     (change)="updateDetailField($event, row.id, 2043)" />
            }

          }
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="year_2034_2038">
        <mat-header-cell *matHeaderCellDef class="year-group number-column expand-collapse-container" [class.check-failed]="isInvalidColumn(tableData.yearColumns, 'year_2034_2038')">
          2034 - 2038
          <button mat-button class="expand-collapse" (click)="toggleExpanded()"><mat-icon svgIcon="chevron_right"></mat-icon></button>
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="year-group number-column" [class.info-cell]="row.id === 'sloop-sloop'">
          @if (row.id !== 'sloop-sloop') {
            {{row.year_2034_2038}}
          }
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="year_2039_2043">
        <mat-header-cell *matHeaderCellDef class="year-group number-column" [class.check-failed]="isInvalidColumn(tableData.yearColumns, 'year_2039_2043')">
          2039 - 2043
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="year-group number-column" [class.info-cell]="row.id === 'sloop-sloop'">
          @if (row.id !== 'sloop-sloop') {
            {{row.year_2039_2043}}
          }
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="years_check" [stickyEnd]="true">
        <mat-header-cell *matHeaderCellDef  class="number-column">Check</mat-header-cell>
        <mat-cell *matCellDef="let row"
                  class="number-column"
                  [class.info-cell]="row.id === 'sloop-sloop'"
                  [class.check-success]="row.years_check === 0"
                  [class.check-failed]="row.years_check !== 0">
          @if (row.id !== 'sloop-sloop') {
            {{row.years_check}}
          }
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="expanded ? displayedColumnsExpanded : displayedColumns; sticky: true;"></mat-header-row>
      <mat-row *matRowDef="let row; columns: expanded ? displayedColumnsExpanded : displayedColumns;" [class]="row.cls"></mat-row>

    </mat-table>
  </div>
}
